'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { pruneData } = require('../../../modules/support/prune-data');

const SharedModal = require('../../shared/views/shared-modal');
const RedemptionRedeem = require('../../redemption/views/redemption-modal-redeem');
const RedemptionTerms = require('../../redemption/views/redemption-modal-terms');
const RedemptionAlert = require('../../redemption/views/redemption-modal-alert');
const RedemptionDisruptor = require('../../redemption/views/redemption-modal-disruptor');

const { publish, subscribe } = require('../../support/event-observer');
const { getOfferRedemptionData } = require('../../support/redemption-helper');
const { withReduxWrapper } = require('../../support/redux-helper');
const storage = require('../../support/storage-helper');
const { waitOnEvent } = require('../../support/event-helper');

class RedemptionProvider extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      redemptionData: null,
    };

    this.setRedemptionData = this.setRedemptionData.bind(this);
  }

  componentDidMount() {
    subscribe('@redemption', this.setRedemptionData);

    this.setRedemption();
  }

  render() {
    const { directRedemption, referralSource } = this.props;
    const { redemptionData } = this.state;

    return withReduxWrapper(
      redemptionData &&
        h(SharedModal, this.getModalProps(), this.getModalContent()),
      {
        directRedemption,
        referralSource,
      }
    );
  }

  setRedemptionData(data) {
    this.setState({
      redemptionData: data,
    });
  }

  getModalProps() {
    const { redemptionData } = this.state;

    const closeHandler = () => {
      publish('@redemption', null);
      storage.setItem('@redemption', null);

      window.history.replaceState(
        {},
        '',
        window.location.href.replace(window.location.search, '')
      );
    };

    const classNames = {
      REDEEM: 'redemption-modal-redeem',
      TERMS: 'redemption-modal-redeem',
      DISRUPT: 'redemption-modal-disruptor',
      ALERT: 'redemption-modal-alert',
    };

    const className = Object.keys(classNames).includes(redemptionData.type)
      ? classNames[redemptionData.type]
      : classNames.ALERT;

    return {
      className,
      closeHandler,
    };
  }

  getModalContent() {
    const { routes, referralSource, directRedemption } = this.props;

    const { redemptionData } = this.state;
    const props = {
      referralSource,
      directRedemption,
      ...redemptionData,
    };

    switch (redemptionData.type) {
      case 'REDEEM':
        props.routes = pruneData(routes, 'redirect');
        return h(RedemptionRedeem, props);
      case 'TERMS':
        props.routes = pruneData(
          routes,
          'outlink:main',
          'redemption:main',
          'redirect:merchant'
        );
        return h(RedemptionTerms, props);
      case 'DISRUPT':
        return h(RedemptionDisruptor, props);
      default:
        return h(RedemptionAlert, props);
    }
  }

  setRedemption() {
    const { directRedemption } = this.props;
    const couponRedeemed = storage.getItem('couponRedeemed');

    if (couponRedeemed) {
      storage.setItem('couponRedeemed', false);

      waitOnEvent({
        doneCheck: () => {
          const data = storage.getItem('@redemption') || {};
          return !!(data.offerCode && data.merchantMedia);
        },
        callback: () => this.setRedemptionData(storage.getItem('@redemption')),
        fallback: () =>
          this.setRedemptionData({
            type: 'ALERT',
            alertMessage: 'GeneralError',
          }),
      });
    } else if (directRedemption) {
      this.setRedemptionData(getOfferRedemptionData(directRedemption));
    }
  }
}

module.exports = hydrate('RedemptionProvider', RedemptionProvider);
